import React from 'react';
import styled from 'styled-components';

import { PaymentInfo } from '@shared/PaymentInfo';
import { BoldText, SubText } from '../styles';
import { Paragraph } from '../../PointsRecovery/styles';

import iconPhone from '../../../images/icon-phone.svg';
import iconLock from '../../../images/icon-lock-circled.svg';
import iconCheckmark from '../../../images/icon-checkmark-circled.svg';
import iconArrow from '../../../images/icon-arrow-circled.svg';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
`;

const BlockContainer = styled.div`
  padding: 16px 24px;
  border-radius: 12px;
  background-color: #fff;
`;

const PhoneContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 10px;
`;

const Icon = styled.img`
  background-image: ${({ src }) => `url(${src})`};
  background-size: contain;
  width: 24px;
  height: 24px;
  display: inline-block;
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InfoBlockContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

const PhoneLink = styled.a`
  text-decoration: none;
  color: inherit;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.5;
`;

const SideInfoBlock = () => (
  <Container>
    <BlockContainer>
      <BoldText fontWeight={700}>Besoin d’un conseil ?</BoldText>
      <Paragraph noMargin>Du Lundi au Vendredi de 9h à 18h</Paragraph>
      <PhoneContainer>
        <Icon alt="Phone icon" src={iconPhone} />
        <PhoneLink href="tel:0970703068">09 70 70 30 68</PhoneLink>
      </PhoneContainer>
      <SubText>Prix d’un appel local</SubText>
    </BlockContainer>
    <PaymentInfo />
    <BlockContainer>
      <InfoContainer>
        <InfoBlockContainer>
          <Icon alt="Lock icon" src={iconLock} />
          <div>
            <BoldText fontWeight={700}>Sécurisé</BoldText>
            <Paragraph noMargin>
              Vos données personnelles sont protégées. Le paiement est sécurisé.
            </Paragraph>
          </div>
        </InfoBlockContainer>
        <InfoBlockContainer>
          <Icon alt="Checkmark" src={iconCheckmark} />
          <div>
            <BoldText fontWeight={700}>Garanti</BoldText>
            <Paragraph noMargin>
              Votre place est réservée, vous recevez immédiatement la convocation et la facture par
              email.
            </Paragraph>
          </div>
        </InfoBlockContainer>
        <InfoBlockContainer>
          <Icon alt="Back arrow" src={iconArrow} />
          <div>
            <BoldText fontWeight={700}>Un empêchement ?</BoldText>
            <Paragraph noMargin>
              Des conditions de transfert et de remboursement les plus flexibles.{' '}
              <a
                href="/a-propos/mentions-legales#cgvactiroute"
                target="_blank"
                rel="noopener noreferrer"
              >
                En savoir plus.
              </a>
            </Paragraph>
          </div>
        </InfoBlockContainer>
      </InfoContainer>
    </BlockContainer>
  </Container>
);

export { SideInfoBlock };
